import React, { useCallback } from 'react';
// import Question from 'js/components/Assessment/Editors/common/components/Questions/Question';
import Question from 'js/components/Assessment/Editors/common/components/Questions/Question';
import { useEditorContext } from 'js/ydoc/docs/capabilities-assessment/EditorContext';
import { getDefaultAnswerSetTypeForQuestionType } from 'js/ydoc/docs/capabilities-assessment/answer-set-utils';

function Element({ element, page, onDelete, ...props }) {
  const {
    doc,
    createAnswerSet,
    addAnswerSetChoice,
    deleteAnswerSetChoice,
    updateAnswerSetChoice,
    updateAnswerSet,
    updateElement,
    assignAnswerSetToQuestion,
    removeElementFromCapabilityPage,
  } = useEditorContext();
  const onFieldFocus = useCallback(() => {}, []);

  const onAnswerSetChange = useCallback(
    (elementGuid, answerSet) => {
      assignAnswerSetToQuestion(elementGuid, answerSet);
    },
    [assignAnswerSetToQuestion]
  );
  const onAnswerSetFieldChange = useCallback(
    (answerSetGuid, updates) => {
      updateAnswerSet(answerSetGuid, updates);
    },
    [updateAnswerSet]
  );
  const onAnswerSetChoiceUpdate = useCallback(
    (answerSetGuid, choiceId, update) => {
      updateAnswerSetChoice(answerSetGuid, choiceId, update);
    },
    [updateAnswerSetChoice]
  );

  const onAnswerSetChoiceAdd = (questionGuid, answerSetGuid, choiceProps) => {
    if (answerSetGuid && element.answerSet) {
      addAnswerSetChoice(answerSetGuid, choiceProps);
    } else {
      doc.transact(() => {
        const newAnswerSetGuid = createAnswerSet(
          {
            type: getDefaultAnswerSetTypeForQuestionType(element.type),
            choices: [choiceProps],
          },
          questionGuid
        );
        updateElement(questionGuid, { answerSetId: newAnswerSetGuid });
      });
    }
  };

  const onAnswerSetChoiceDelete = (answerSetGuid, choiceId) => {
    deleteAnswerSetChoice(answerSetGuid, choiceId);
  };
  const onCreateCustomAnswerSet = () => {};

  // addAnswerSetChoice: () => {},
  // deleteAnswerSetChoice: () => {},
  // updateAnswerSetChoice: () => {},
  // moveAnswerSetChoiceBefore: () => {},
  // moveAnswerSetChoiceAfter: () => {},

  const handleFieldChange = useCallback(
    (elementGuid, field, value) => {
      updateElement(elementGuid, { [field]: value });
    },
    [updateElement]
  );

  const handleDelete = useCallback(() => {
    if (onDelete) {
      onDelete(element);
    } else {
      removeElementFromCapabilityPage(page.guid, element.guid);
    }
  }, [onDelete, removeElementFromCapabilityPage, page.guid, element]);

  return (
    <Question
      {...props}
      question={element}
      onAnswerSetChange={onAnswerSetChange}
      onAnswerSetFieldChange={onAnswerSetFieldChange}
      onAnswerSetChoiceUpdate={onAnswerSetChoiceUpdate}
      onAnswerSetChoiceAdd={onAnswerSetChoiceAdd}
      onAnswerSetChoiceDelete={onAnswerSetChoiceDelete}
      onCreateCustomAnswerSet={onCreateCustomAnswerSet}
      onFieldChange={handleFieldChange}
      onFieldFocus={onFieldFocus}
      onDelete={handleDelete}
    />
  );
}

export default Element;
